module.exports = __webpack_public_path__ + "static/media/loading.fb9ac4f.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/public/3d/res/imgs/joystick/loading.mp4
// module id = cFyO
// module chunks = 1